import React, { useEffect } from 'react';
import ZimmerBlock from "./components/zimmermanBlock";
import SuryaBlockMap from './components/nexttrackerBlock';
import { setStoredBulkData, setStoredSelectedRows } from './utils/selectionUtils';
export function BlockMap(props) {
  useEffect(() => {
    // Extract bulk data (combined piers and tt data)
    const bulkData = props.data || {};
    // Extract selected rows
    const selectedRows = props.selectedRow || {};

    // Store in context
    setStoredBulkData(bulkData);
    setStoredSelectedRows(selectedRows);
  }, [props.data, props.selectedRow]);
  if (props?.type?.projectType === "zimmerman") {
    return /*#__PURE__*/React.createElement(ZimmerBlock, {
      datas: props
    });
  } else {
    return /*#__PURE__*/React.createElement(SuryaBlockMap, {
      datas: props
    });
  }
}
export default BlockMap;